// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/material.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Upload } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/material.proto.
 */
export const file_api_proto_v1_material: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_file]);

/**
 * AIカラーシミュレーションで扱う素材のマスター情報
 *
 * @generated from message api_proto.v1.Material
 */
export type Material = Message<"api_proto.v1.Material"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 対象部位 ("wall" | "roof")
   *
   * @generated from field: string target_part = 2;
   */
  targetPart: string;

  /**
   * メーカー名（例: ディーズルーフィング）
   *
   * @generated from field: string manufacturer_name = 3;
   */
  manufacturerName: string;

  /**
   * ブランド/シリーズ名（例: DIPLOMAT STAR/II）
   *
   * @generated from field: string brand_name = 4;
   */
  brandName: string;

  /**
   * 品番
   *
   * @generated from field: string product_code = 5;
   */
  productCode: string;

  /**
   * カラー名（例: オニキス）
   *
   * @generated from field: string color_name = 6;
   */
  colorName: string;

  /**
   * 見本画像の署名付きURL
   *
   * @generated from field: string thumbnail_url = 7;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: int32 display_order = 8;
   */
  displayOrder: number;

  /**
   * 実例（施工事例）画像の署名付きURL（未設定なら空文字）
   *
   * @generated from field: string construction_example_image_url = 9;
   */
  constructionExampleImageUrl: string;

  /**
   * 素材の向き。"" = 未指定 / "horizontal" = 横 / "vertical" = 縦。
   * 素材変更の生成指示に「模様の走る向き」のヒントとして渡す（未指定なら渡さない）。
   *
   * @generated from field: string orientation = 10;
   */
  orientation: string;

  /**
   * 素材別の生成指示。共通プロンプトテンプレートに**追加**される（置き換えではない）。未設定なら空文字。
   *
   * @generated from field: string prompt = 11;
   */
  prompt: string;
};

/**
 * Describes the message api_proto.v1.Material.
 * Use `create(MaterialSchema)` to create a new message.
 */
export const MaterialSchema: GenMessage<Material> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 0);

/**
 * 企業の使用可能な素材一覧（素材変更シミュレーション表示用）
 *
 * @generated from message api_proto.v1.ListCompanyMaterialsRequest
 */
export type ListCompanyMaterialsRequest = Message<"api_proto.v1.ListCompanyMaterialsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListCompanyMaterialsRequest.
 * Use `create(ListCompanyMaterialsRequestSchema)` to create a new message.
 */
export const ListCompanyMaterialsRequestSchema: GenMessage<ListCompanyMaterialsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 1);

/**
 * @generated from message api_proto.v1.ListCompanyMaterialsResponse
 */
export type ListCompanyMaterialsResponse = Message<"api_proto.v1.ListCompanyMaterialsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.Material materials = 1;
   */
  materials: Material[];
};

/**
 * Describes the message api_proto.v1.ListCompanyMaterialsResponse.
 * Use `create(ListCompanyMaterialsResponseSchema)` to create a new message.
 */
export const ListCompanyMaterialsResponseSchema: GenMessage<ListCompanyMaterialsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 2);

/**
 * Admin: 素材マスター検索（メーカー絞込・フリーワード・ページネーション）
 *
 * @generated from message api_proto.v1.ListMaterialsRequest
 */
export type ListMaterialsRequest = Message<"api_proto.v1.ListMaterialsRequest"> & {
  /**
   * "" / "wall" / "roof"
   *
   * @generated from field: string target_part = 1;
   */
  targetPart: string;

  /**
   * "" = 全メーカー
   *
   * @generated from field: string manufacturer_name = 2;
   */
  manufacturerName: string;

  /**
   * brand_name / product_code / color_name / manufacturer_name の部分一致
   *
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * 取得件数（デフォルト50）
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * オフセット
   *
   * @generated from field: int32 offset = 5;
   */
  offset: number;
};

/**
 * Describes the message api_proto.v1.ListMaterialsRequest.
 * Use `create(ListMaterialsRequestSchema)` to create a new message.
 */
export const ListMaterialsRequestSchema: GenMessage<ListMaterialsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 3);

/**
 * @generated from message api_proto.v1.ListMaterialsResponse
 */
export type ListMaterialsResponse = Message<"api_proto.v1.ListMaterialsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.Material materials = 1;
   */
  materials: Material[];

  /**
   * フィルタ条件に合致する全件数
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message api_proto.v1.ListMaterialsResponse.
 * Use `create(ListMaterialsResponseSchema)` to create a new message.
 */
export const ListMaterialsResponseSchema: GenMessage<ListMaterialsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 4);

/**
 * Admin: 素材マスターのメーカー一覧（フィルタUI用、distinct）
 *
 * @generated from message api_proto.v1.ListMaterialManufacturersRequest
 */
export type ListMaterialManufacturersRequest = Message<"api_proto.v1.ListMaterialManufacturersRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMaterialManufacturersRequest.
 * Use `create(ListMaterialManufacturersRequestSchema)` to create a new message.
 */
export const ListMaterialManufacturersRequestSchema: GenMessage<ListMaterialManufacturersRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 5);

/**
 * @generated from message api_proto.v1.ListMaterialManufacturersResponse
 */
export type ListMaterialManufacturersResponse = Message<"api_proto.v1.ListMaterialManufacturersResponse"> & {
  /**
   * @generated from field: repeated string manufacturer_names = 1;
   */
  manufacturerNames: string[];
};

/**
 * Describes the message api_proto.v1.ListMaterialManufacturersResponse.
 * Use `create(ListMaterialManufacturersResponseSchema)` to create a new message.
 */
export const ListMaterialManufacturersResponseSchema: GenMessage<ListMaterialManufacturersResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 6);

/**
 * Admin: 素材マスターを単体追加（thumbnail は必須）
 *
 * @generated from message api_proto.v1.CreateMaterialRequest
 */
export type CreateMaterialRequest = Message<"api_proto.v1.CreateMaterialRequest"> & {
  /**
   * @generated from field: string target_part = 1;
   */
  targetPart: string;

  /**
   * @generated from field: string manufacturer_name = 2;
   */
  manufacturerName: string;

  /**
   * @generated from field: string brand_name = 3;
   */
  brandName: string;

  /**
   * @generated from field: string product_code = 4;
   */
  productCode: string;

  /**
   * @generated from field: string color_name = 5;
   */
  colorName: string;

  /**
   * @generated from field: api_proto.v1.Upload thumbnail = 6;
   */
  thumbnail?: Upload;

  /**
   * @generated from field: int32 display_order = 7;
   */
  displayOrder: number;

  /**
   * 実例（施工事例）画像（任意）
   *
   * @generated from field: optional api_proto.v1.Upload construction_example_image = 8;
   */
  constructionExampleImage?: Upload;

  /**
   * "" / "horizontal" / "vertical"。それ以外は不正値として拒否する
   *
   * @generated from field: string orientation = 9;
   */
  orientation: string;

  /**
   * 素材別の生成指示（任意）
   *
   * @generated from field: string prompt = 10;
   */
  prompt: string;
};

/**
 * Describes the message api_proto.v1.CreateMaterialRequest.
 * Use `create(CreateMaterialRequestSchema)` to create a new message.
 */
export const CreateMaterialRequestSchema: GenMessage<CreateMaterialRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 7);

/**
 * @generated from message api_proto.v1.CreateMaterialResponse
 */
export type CreateMaterialResponse = Message<"api_proto.v1.CreateMaterialResponse"> & {
  /**
   * @generated from field: api_proto.v1.Material material = 1;
   */
  material?: Material;
};

/**
 * Describes the message api_proto.v1.CreateMaterialResponse.
 * Use `create(CreateMaterialResponseSchema)` to create a new message.
 */
export const CreateMaterialResponseSchema: GenMessage<CreateMaterialResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 8);

/**
 * Admin: 素材マスターを単体更新（thumbnail 省略時は既存画像を保持）
 *
 * @generated from message api_proto.v1.UpdateMaterialRequest
 */
export type UpdateMaterialRequest = Message<"api_proto.v1.UpdateMaterialRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string target_part = 2;
   */
  targetPart: string;

  /**
   * @generated from field: string manufacturer_name = 3;
   */
  manufacturerName: string;

  /**
   * @generated from field: string brand_name = 4;
   */
  brandName: string;

  /**
   * @generated from field: string product_code = 5;
   */
  productCode: string;

  /**
   * @generated from field: string color_name = 6;
   */
  colorName: string;

  /**
   * @generated from field: optional api_proto.v1.Upload thumbnail = 7;
   */
  thumbnail?: Upload;

  /**
   * @generated from field: int32 display_order = 8;
   */
  displayOrder: number;

  /**
   * 実例（施工事例）画像（省略時は既存画像を保持）
   *
   * @generated from field: optional api_proto.v1.Upload construction_example_image = 9;
   */
  constructionExampleImage?: Upload;

  /**
   * "" / "horizontal" / "vertical"。それ以外は不正値として拒否する
   *
   * @generated from field: string orientation = 10;
   */
  orientation: string;

  /**
   * 素材別の生成指示（空文字 = 未設定に戻す）
   *
   * @generated from field: string prompt = 11;
   */
  prompt: string;
};

/**
 * Describes the message api_proto.v1.UpdateMaterialRequest.
 * Use `create(UpdateMaterialRequestSchema)` to create a new message.
 */
export const UpdateMaterialRequestSchema: GenMessage<UpdateMaterialRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 9);

/**
 * @generated from message api_proto.v1.UpdateMaterialResponse
 */
export type UpdateMaterialResponse = Message<"api_proto.v1.UpdateMaterialResponse"> & {
  /**
   * @generated from field: api_proto.v1.Material material = 1;
   */
  material?: Material;
};

/**
 * Describes the message api_proto.v1.UpdateMaterialResponse.
 * Use `create(UpdateMaterialResponseSchema)` to create a new message.
 */
export const UpdateMaterialResponseSchema: GenMessage<UpdateMaterialResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 10);

/**
 * Admin: 素材マスターを論理削除
 *
 * @generated from message api_proto.v1.DeleteMaterialRequest
 */
export type DeleteMaterialRequest = Message<"api_proto.v1.DeleteMaterialRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteMaterialRequest.
 * Use `create(DeleteMaterialRequestSchema)` to create a new message.
 */
export const DeleteMaterialRequestSchema: GenMessage<DeleteMaterialRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 11);

/**
 * @generated from message api_proto.v1.DeleteMaterialResponse
 */
export type DeleteMaterialResponse = Message<"api_proto.v1.DeleteMaterialResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMaterialResponse.
 * Use `create(DeleteMaterialResponseSchema)` to create a new message.
 */
export const DeleteMaterialResponseSchema: GenMessage<DeleteMaterialResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_material, 12);

